




























import { Swipe, SwipeItem } from 'vant'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  }
})
export default class GridSection extends Vue {
  @Prop({ default: () => ({}) }) readonly activityInfo!: any

  get storeName() {
    if (this.activityInfo.distance) {
      const dis = +this.activityInfo.distance
      if (dis < 1000) {
        return `${this.activityInfo.storeName} | ${dis}m`
      } else {
        return `${this.activityInfo.storeName} | ${(dis / 1000).toFixed(1)}km`
      }
    } else {
      return this.activityInfo.storeName
    }
  }

  get activitys() {
    if (this.activityInfo.nearByActivities && this.activityInfo.nearByActivities.length >= 2) {
      let listData: any[] = []
      let activitysData: any[] = []
      const size = this.activityInfo.nearByActivities.length
      for (let index = 0; index < size; index++) {
        listData.push(this.activityInfo.nearByActivities[index])
        if (listData.length == 2) {
          const activitys = {
            datas: [...listData]
          }
          activitysData.push(activitys)
          listData = []
        }
      }
      return activitysData
    } else {
      return []
    }
  }
  childClick() {
    this.$emit('track-click', { clickId: '200036' })
    location.href = this.activityInfo.kidsIndexLink
  }

  rechargeClick() {
    this.$emit('track-click', { clickId: '200036' })
    location.href = this.activityInfo.myKidsWalletLink
  }

  clickPro(data: any) {
    this.$emit('track-click', { clickId: '200035' })
    location.href = `https://w.cekid.com/interaction-activity/detail/${data.activityId}`
  }

  toStore() {
    this.$emit('track-click', { clickId: '200035' })
    location.href = `https://w.cekid.com/interaction-activity/storeactlist/?entityid=${this.activityInfo.storeCode}`
  }
}
